import { render, staticRenderFns } from "./StatusTab.vue?vue&type=template&id=386fe6ec&scoped=true&"
import script from "./StatusTab.vue?vue&type=script&lang=ts&"
export * from "./StatusTab.vue?vue&type=script&lang=ts&"
import style0 from "./StatusTab.vue?vue&type=style&index=0&id=386fe6ec&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "386fe6ec",
  null
  
)

export default component.exports